{
  "guidance": {
    "coaches": {
      "C03": {
        "title": "Source a need",
        "summary": "Open a draft enquiry, compare supplier responses and record your authorised award.",
        "welcome": {
          "title": "From enquiry to sourcing decision",
          "body": "Start with an existing draft in your sourcing queue. You choose suppliers and make each decision. This guide performs no business action. If you still need to prepare a draft, pause and use the normal enquiry form first."
        },
        "open-draft": {
          "title": "Open your draft enquiry",
          "body": "Open an enquiry labelled Draft in this queue. Choose a record you are authorised to manage; the guide does not choose one for you."
        },
        "requirement": {
          "title": "Check the requirement and deadline",
          "body": "Review the draft summary, requested quantities, currency and response deadline. Opening asks suppliers for offers; it does not place an order or commit budget."
        },
        "invite": {
          "title": "Choose who to invite",
          "body": "Review the suppliers available to you. When the guide hands control back, choose the suppliers appropriate for this requirement. It recommends none and selects none."
        },
        "publish-handoff": {
          "title": "Open the enquiry yourself",
          "body": "You now choose suppliers and press Open to suppliers on the page. Check the requirement and deadline before you act.",
          "consequence": "Opening makes this enquiry available to the invited suppliers and allocates its reference. It does not create a purchase order."
        },
        "publish": {
          "title": "Waiting for your opened enquiry",
          "body": "Choose the suppliers and use the page's Open to suppliers action. The guide waits for the server to accept it. A refusal keeps you here.",
          "blocked": "Choose at least one eligible supplier on this draft. If the page refuses opening, follow its explanation and retry the same action."
        },
        "compare": {
          "title": "Compare real supplier responses",
          "body": "Compare price, validity, minimum quantity, lead time and availability. There is no automatic winner. If no suitable response has arrived, pause and return when suppliers have responded; do not award an unsuitable offer just to finish the guide."
        },
        "award-handoff": {
          "title": "Choose and award an offer yourself",
          "body": "You now select a valid offer, explain your decision and use Award to the chosen supplier on the page. Closing without an award is a different business outcome; the guide never claims it was an award.",
          "consequence": "Awarding records your authorised choice and creates a draft framework agreement for the purchasing unit the need came from. It does not create an order or commit budget; somebody with agreement authority activates it before anything can be bought, and any purchase follows the normal request and order flow."
        },
        "award": {
          "title": "Waiting for your award",
          "body": "Choose a valid response and enter a meaningful award reason. Press Award to the chosen supplier yourself. Continue only after the page confirms the server's decision.",
          "blocked": "Choose a valid response and provide the reason required by the page. An expired or unsuitable offer should not be awarded; pause this guide if you need another response."
        },
        "result": {
          "title": "Check the sourcing outcome",
          "body": "Check that the enquiry says Awarded and review the draft agreement it created: where it applies and until when. Activating it and raising a purchase remain separate authorised actions."
        },
        "finish": {
          "title": "Sourcing guide finished",
          "body": "You performed the opening and award; the guide only observed their accepted outcomes. Finish stores guide progress only, not business acceptance."
        }
      },
      "C04": {
        "title": "Manage a purchase order",
        "summary": "Review a draft, issue it, send the current version and understand the next actors.",
        "welcome": {
          "title": "From draft to supplier handoff",
          "body": "Start with an existing draft order you are authorised to issue and send. You perform both actions. The guide does not issue, send, amend, receive or record invoices."
        },
        "open-draft": {
          "title": "Open your draft order",
          "body": "Open a Draft order in the list. If an order is already issued, use a fresh draft for this workflow or resume an existing guide at its recorded step."
        },
        "terms": {
          "title": "Review the order before committing",
          "body": "Check supplier, delivery location, items, quantities, prices, currency and totals. The draft is not yet a commercial commitment."
        },
        "status": {
          "title": "Read the four separate dimensions",
          "body": "Lifecycle, supplier response, fulfilment and invoice evidence answer different questions. Issuing an order does not mean the supplier accepted it, goods arrived or an invoice was recorded."
        },
        "issue-handoff": {
          "title": "Issue the order yourself",
          "body": "You now press Issue order on the page after checking the draft. The guide does not press it for you.",
          "consequence": "Issuing numbers the order, freezes its current commercial version and commits the applicable budget. It does not record receipt or payment."
        },
        "issue": {
          "title": "Waiting for your issued order",
          "body": "Use the page's Issue order action. The guide waits for the accepted server outcome and the issued lifecycle. If the server refuses, correct the cause shown on the page and retry."
        },
        "send-handoff": {
          "title": "Send the current version yourself",
          "body": "You now use Send to supplier on the page. On a phone, open More actions to find it. Check that you are sending the version you intend.",
          "consequence": "Sending delivers the current order version through the existing supplier notification flow. It does not count as supplier acceptance or goods received."
        },
        "send": {
          "title": "Waiting for your supplier handoff",
          "body": "Use Send to supplier yourself; on a phone it is under More actions. The guide waits for the server's successful send and the recorded send time. A refusal never advances the guide."
        },
        "responses": {
          "title": "Follow the supplier's response",
          "body": "The supplier can acknowledge, query, decline or report availability through their own channel. Read the actual response and any exception. Supplier response and receipt remain separate; a receiver records the delivery."
        },
        "versions": {
          "title": "Keep the commercial evidence clear",
          "body": "Review the issued version history. Any later amendment, cancellation, receipt or invoice evidence uses its own authorised workflow; the guide changes none of it."
        },
        "finish": {
          "title": "Purchase-order guide finished",
          "body": "You issued and sent the order. Finish records only your guide progress. Supplier response, delivery, invoice evidence and payment are separate facts."
        }
      }
    }
  }
}
